import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralLevelsComponent } from '@common/config/ReferralsLevels';
import { ReferralIncomeTable } from '@components/Partners/ReferralIncomeTable/ReferralIncomeTable';
import { Tab } from '@components/Tabs/Tab';
import { Tabs } from '@components/Tabs/Tabs';
import { TabsNavigation } from '@components/Tabs/TabsNavigation';
import { H1 } from '@components/Typography/Typography';
import { Close } from '@components/ui/Close/Close';

import { ModalContext } from '../Modal/config';

import css from './styles.module.scss';

const ReferralModal: FC = () => {
  const { closeModal } = useContext(ModalContext);
  const { t } = useTranslation();
  const referralLevels = ReferralLevelsComponent();

  return (
    <div className="relative w-full overflow-y-auto h-[63.93vh] pt-7 px-4">
      <Close
        onClick={closeModal}
        className="absolute right-4 top-4 z-20"
        imageVariant="modal"
        variant="modal"
      />
      <div className={css.effect}></div>
      <div className={css.gradient}></div>
      <div className="relative z-10 flex flex-col items-center">
        <H1 weight="bold" className="mb-8 max-w-[10.625rem] text-center">
          {t('Rewards table')}
        </H1>
        <Tabs initActiveTab="1">
          <TabsNavigation list={referralLevels} />
          <Tab tabId="1">
            <ReferralIncomeTable level="1" />
          </Tab>
          <Tab tabId="2">
            <ReferralIncomeTable level="2" />
          </Tab>
          <Tab tabId="3">
            <ReferralIncomeTable level="3" />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export { ReferralModal };
